import { Services } from "appworks/services/services";
import { ButtonControl } from "./button-control";

export class AutoplayControl extends ButtonControl {
    public setEnabled(enabled: boolean) {
        const juriAllowsAutoplay = Services.jurisdiction.getAutoplayEnabled();

        if (!juriAllowsAutoplay) {
            super.setEnabled(false);
            this.button.setVisible(false);
        } else {
            super.setEnabled(enabled);
        }
    }
}
